import { render, staticRenderFns } from "./CampaignBuilderLine.vue?vue&type=template&id=56388d05&"
import script from "./CampaignBuilderLine.vue?vue&type=script&lang=js&"
export * from "./CampaignBuilderLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports